import React, { useRef, useEffect } from "react";
import './joystick.css';

export default function Joystick({ onMove, sensitivity = 0.35 }) {
  const stickRef = useRef(null);
  const baseRef = useRef(null);
  const dragging = useRef(false);

  function getRelativePosition(e) {
    const rect = baseRef.current.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    return { x, y };
  }

  function handleStart(e) {
    dragging.current = true;
    handleMove(e);
  }

  function handleMove(e) {
    if (!dragging.current) return;
    e.preventDefault();
    const { x, y } = getRelativePosition(e);
    const size = 80;
    const dx = x - size / 2;
    const dy = y - size / 2;
    const dist = Math.min(Math.sqrt(dx * dx + dy * dy), size / 2);
    const angle = Math.atan2(dy, dx);
    // compute raw stick offset (clamped to radius)
    const rawX = Math.cos(angle) * dist;
    const rawY = Math.sin(angle) * dist;

    // apply sensitivity: lower values make the joystick less responsive
    const stickX = rawX * sensitivity;
    const stickY = rawY * sensitivity;
    stickRef.current.style.transform = `translate(${stickX}px, ${stickY}px)`;

    // normalized output in range [-1, 1], apply sensitivity multiplier
    const normX = Math.max(-1, Math.min(1, (rawX / (size / 2)) * sensitivity));
    const normY = Math.max(-1, Math.min(1, (rawY / (size / 2)) * sensitivity));
    if (onMove) onMove({ x: normX, y: normY });
  }

  function handleEnd() {
    dragging.current = false;
    stickRef.current.style.transform = "translate(0px, 0px)";
    if (onMove) onMove({ x: 0, y: 0 });
  }

  useEffect(() => {
    const base = baseRef.current;
    if (!base) return;

    // Touch listeners need passive: false to allow preventDefault()
    const opts = { passive: false };

    function touchStart(e) {
      handleStart(e);
    }

    function touchMove(e) {
      handleMove(e);
    }

    function touchEnd(e) {
      handleEnd(e);
    }

    base.addEventListener('touchstart', touchStart, opts);
    base.addEventListener('touchmove', touchMove, opts);
    // touchend may happen outside the base, listen on document
    document.addEventListener('touchend', touchEnd, opts);
    document.addEventListener('touchcancel', touchEnd, opts);

    return () => {
      base.removeEventListener('touchstart', touchStart, opts);
      base.removeEventListener('touchmove', touchMove, opts);
      document.removeEventListener('touchend', touchEnd, opts);
      document.removeEventListener('touchcancel', touchEnd, opts);
    };
  }, []);

  return (
    // <div
    //   className="joystick-base"
    //   ref={baseRef}
    //   onTouchStart={handleStart}
    //   onTouchMove={handleMove}
    //   onTouchEnd={handleEnd}
    //   onMouseDown={handleStart}
    //   onMouseMove={handleMove}
    //   onMouseUp={handleEnd}
    //   onMouseLeave={handleEnd}
    // >
    //   <div className="joystick-stick" ref={stickRef} />
    // </div>
        <div className="joystick-wrapper">
      <img src="/images/left-arrow.png" alt="left" className="joystick-icon joystick-icon-left" />

      <div
        className="joystick-base"
        ref={baseRef}
        onMouseDown={handleStart}
        onMouseMove={handleMove}
        onMouseUp={handleEnd}
        onMouseLeave={handleEnd}
      >
        <div className="joystick-stick" ref={stickRef} />
      </div>

      <img src="/images/right-arrow.png" alt="right" className="joystick-icon joystick-icon-right" />
    </div>
  );
}
